var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGradientedListMarker = function SvgGradientedListMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientedListMarker_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb100"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m4.247 7.341-6.389 7.3L10.6 16.2l-1.2 1.6 4.742 3.556 7.611-8.7z",
    "data-name": "approve,-check,-circle,-correct",
    style: {
      fill: "url(#GradientedListMarker_svg__a)"
    },
    transform: "translate(-4 -4)"
  })));
};
export default SvgGradientedListMarker;